import { Link } from "@tanstack/react-router";

const Footer = () => {
  return (
    <footer className="flex w-full  flex-col gap-4 bg-primary text-white p-8 pb-10 mt-20">
      <div className="container flex flex-col gap-8">
        <div className="flex items-center justify-between gap-2 md:text-xl">
          <img
            className="size-36"
            src="/logo-transparent.png"
            alt="transcript-genie-logo"
            width={1000}
            height={1000}
          />
          <div className="flex flex-col gap-6">
            <h4>Links</h4>
            <ul className="text-sm md:text-base flex flex-col gap-5">
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              {/* https://gennexteducation.com/privacy-policy/ */}
              <li>
                <a href={"https://gennexteducation.com/privacy-policy/"}>
                  Privacy
                </a>
              </li>
              {/* mailto:wish@collegegenie.org */}
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://gennexteducation.com/contact"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <a href={"https://gennexteducation.com/"} className="leading-loose">
            Copyright.{" "}
            <span className="underline underline-offset-4">
              Gen Next Education
            </span>{" "}
            , Inc. 2024. All Rights Reserved.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
